import React from 'react'
import './map.css'

const Map = () => {
  return (
    <section id='map__Pintos91'>
        <div className="container map__Pintos91__container">

        <article>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d104991.36113252646!2d-58.55855630520869!3d-34.680453343795214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc92f70e1b09f%3A0xde5b0f38a6cf97ac!2sConfiteria%20Kyrios!5e0!3m2!1ses-419!2sar!4v1661970310543!5m2!1ses-419!2sar" width="100%"></iframe>
        </article>
            
        </div>
    </section>
  )
}

export default Map